import { render, staticRenderFns } from "./LeadDetail.vue?vue&type=template&id=7d810876&scoped=true"
import script from "./LeadDetail.vue?vue&type=script&lang=js"
export * from "./LeadDetail.vue?vue&type=script&lang=js"
import style0 from "./LeadDetail.vue?vue&type=style&index=0&id=7d810876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d810876",
  null
  
)

export default component.exports